import { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import RedirectionForm from './RedirectionAction';
import axios from 'axios';
import { fetchToken } from '../../../../Auth';
import { Button, Tooltip, IconButton } from "@mui/material";
import { Refresh, InfoOutlined } from "@mui/icons-material";
import { toast } from 'react-toastify';

const Redirection = () => {
    const [redirections, setRedirections] = useState([]);
    const [fetch, setFetch] = useState(false);
    const [createPrivilege, setCreatePrivilege] = useState(false);
    const [editPrivilege, setEditPrivilege] = useState(false);
    const [deletePrivilege, setDeletePrivilege] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [selectedRedirection, setSelectedRedirection] = useState(null);

    useEffect(() => {
        getPrivileges();
    }, []);

    useEffect(() => {
        getRedirections();
    }, [fetch]);

    const getPrivileges = async () => {
        try {
            const response = await axios.get(`/get_privileges`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
                },
            });
            if (response.status === 200 && response.data) {
                let privileges = response.data['6'];
                if (privileges['edit']) setEditPrivilege(true);
                if (privileges['create']) setCreatePrivilege(true);
                if (privileges['delete']) setDeletePrivilege(true);
                setFetch(true);
            }
        } catch (err) {
            console.error("Error", err);
        }
    };

    const getRedirections = async () => {
        try {
            const response = await axios.get(`/backend/get_all_redirection`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
                },
            });
            if (response.status === 200 && response.data) {
                setRedirections(response.data.redirected_data)
            }


        } catch (err) {
            console.log('reached hererererewrjnewkrnej')
            console.error("Error", err);
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(`/backend/delete_redirection/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
                },
            });
            if (response.status === 200 && response.data) {
                toast.success('Redirection mapping deleted successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                getRedirections()
            }

        } catch (err) {
            console.error("Error", err);
        }
    };

    const handleEdit = (redirection) => {
        setSelectedRedirection(redirection);
        setShowForm(true);
    };

    const handleCreate = () => {
        setSelectedRedirection(null);
        setShowForm(true);
    };

    const handleCloseForm = () => {
        setShowForm(false);
        getRedirections();
    };

    const columns = [
        { field: 'id', headerName: 'Sr. No.', flex: 1 },
        { field: 'mapped_url', headerName: 'Mapped URL', flex: 2 },
        { field: 'oldUrls', headerName: 'Redirect From', flex: 2, renderCell: (params) => params.value.join(", ") },
    ];

    if (editPrivilege) {
        columns.push({
            field: 'edit', headerName: 'Edit', flex: 1, renderCell: (params) => (
                <IconButton onClick={() => handleEdit(params.row)}>
                    <EditIcon />
                </IconButton>
            )
        });
    }

    if (deletePrivilege) {
        columns.push({
            field: 'delete', headerName: 'Delete', flex: 1, renderCell: (params) => (
                <IconButton onClick={() => handleDelete(params.row.id)}>
                    <DeleteIcon />
                </IconButton>
            )
        });
    }

    const updateRedirection = async () => {
        try {
            const response = await axios.get(`/backend/generate_redirection_json`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
                },
            });
            if (response.status === 200 && response.data) {
                toast.success('Redirection mapping Updated successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });

                getRedirections()
            }
        } catch (err) {
            console.error("Error", err);
        }
    }

    return (
        <div className="p-4">
            {!showForm ? (
                <>
                    <h1>Redirection Dashboard</h1>
                    <div className='col-12 d-flex justify-content-between align-items-center'>
                        {createPrivilege &&
                            (
                                <>
                                    <Button style={{height:'3em'}} variant="contained" onClick={handleCreate}>Create Redirection</Button>
                                </>
                            )}
                        {editPrivilege && (
                            <>
                                <div className="d-flex align-items-center flex-column">
                                    
                                    <p style={{ color: "red", fontSize: "12px" }}>
                                        Note: To reflect changes click on update.
                                    </p>


                                    {/* Update Redirection Button with Refresh Icon */}
                                    <Button
                                        variant="contained"
                                        onClick={updateRedirection}
                                        startIcon={<Refresh />}
                                        color="secondary"
                                        disabled={redirections.length == 0}
                                    >
                                        Update Redirection
                                    </Button>

                                    {/* Info Icon with Popover */}
                                    {/* <Tooltip title="Click this after adding/removing a mapped URL or modifying an existing redirection to update the configuration." arrow>
                                <IconButton size="small">
                                    <InfoOutlined />
                                </IconButton>
                            </Tooltip> */}

                                </div>
                            </>
                        )}

                    </div>
                    <div className="mt-3">
                        <DataGrid rows={redirections} columns={columns} pageSize={5} />
                    </div>
                </>
            ) : (
                <RedirectionForm mode={selectedRedirection ? 'edit' : 'create'} data={selectedRedirection} handleCloseForm={handleCloseForm} />
            )}
        </div>
    );
};

export default Redirection;
